import { Map } from 'maplibre-gl';

export const SOURCE_ID = 'hm-chunked-roadData';

export async function addSource(map: Map) {
  if (map && !map.getSource(SOURCE_ID)) {
    const tilesUrl =
      'https://network-tiles.s3.us-west-2.amazonaws.com/USA_chunked_tileset.pmtiles';
    try {
      map.addSource(SOURCE_ID, {
        type: 'vector',
        url: 'pmtiles://' + tilesUrl,
        promoteId: 'id',
      });
    } catch (err) {
      console.log(err);
    }
  }
}
